
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AnalyzerList',
  props: {
    itemsZClass: {
      type: String,
      default: 'z-20',
      validator: (val: string) => val.startsWith('z-')
    }
  },
  computed: {
    othersListCount(): number | undefined {
      return this.$slots?.['others-list']?.length
    }
  }
})
